/**
 * Точка на цифровом блоке в русской раскладке даёт запятую, и число ломается.
 *
 * Ориентируемся не на символ, а на физическую клавишу (e.code) — тогда раскладка
 * не важна: NumpadDecimal / NumpadComma всегда вставляют точку.
 *
 * Вставляем вручную, потому что дальше значение уходит в обработчик поля со своей
 * логикой (пересчёт сумм, обрезка знаков) — подменять value у DOM-узла нельзя.
 *
 *   onKeyDown={(e) => handleDecimalKeyDown(e, (event) => handleInputChange(event, index))}
 */
export function handleDecimalKeyDown(e, applyChange) {
	if (e.code !== 'NumpadDecimal' && e.code !== 'NumpadComma') return
	if (e.ctrlKey || e.altKey || e.metaKey) return
	// в английской раскладке клавиша и так даёт точку — не мешаем
	if (e.key === '.') return

	e.preventDefault()

	const input = e.target
	const start = input.selectionStart ?? input.value.length
	const end = input.selectionEnd ?? start
	const value = input.value.slice(0, start) + '.' + input.value.slice(end)

	applyChange({ target: { name: input.name, value: value } })
}

export default handleDecimalKeyDown
